// contexts/GraphContext.ts
// Response shapes are intentionally `unknown` here — will be tightened once the
// dashboard API responses are typed and the GraphProvider is fully analysed.
import { createContext, useContext } from 'react';

export interface GraphContextValue {
    impressionSummary: unknown;
    impressionsBeforeVisit: unknown;
    responsesByRegion: unknown;
    responsesBySite: unknown;
    responsesOverTime: unknown;
    visitResponseTiming: unknown;
    creativePerformanceCost: unknown;
    channelPerformanceCost: unknown;
    bookingPerformanceCost: unknown;
    impressionHeatmap: unknown;
    campaignUplift: unknown;
    uniqueReach: unknown;
    reachBreakdown: unknown;
    analysisResult: unknown;
    analysisStreamText: string;
    analysisLoading: boolean;
    fetchAnalysis: (params: RefreshDataParams) => void;
    optimisationResult: unknown;
    optimisationStreamText: string;
    optimisationLoading: boolean;
    fetchOptimisation: (params: RefreshDataParams) => void;
    hasGraphData: boolean;
    /** Last day of the range the widgets' data was fetched for (YYYY-MM-DD), null before any */
    dataEndDate: string | null;
    loading: boolean;
    selectedCustomer: string;
    setSelectedCustomer: (id: string) => void;
    selectedClient: string;
    setSelectedClient: (id: string) => void;
    refreshData: (params: RefreshDataParams) => Promise<void>;
    resetData: () => void;
}

export interface RefreshDataParams {
    clientId: number | string;
    selectedDateRange?: { startDate?: Date | string; endDate?: Date | string } | null;
    selectedRegions?: number[];
    selectedCampaigns?: number[];
    selectedBookings?: number[];
    selectedCreatives?: number[];
    selectedChannels?: number[];
    selectedWeekdays?: number[];
    selectedDayparts?: number[];
    selectedSites?: number[];
}

export const GraphContext = createContext<GraphContextValue | null>(null);

export const useGraphData = (): GraphContextValue => {
    // Returns empty object fallback to prevent crashes when GraphProvider isn't available
    return useContext(GraphContext) ?? ({} as GraphContextValue);
};
